<!--element 历史事件-->
<template>
  <div class="myelEventBody">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <div class="input-small mr-20">
          <span>事件类型：</span>
          <el-select
            v-model="form.eventType"
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              label="全选"
              value="全选"
              @click.native="selectAll"
            ></el-option>
            <el-option
              v-for="item in getEventTypes"
              :key="item.id"
              :label="item.name"
              :value="item.no"
            >
            </el-option>
          </el-select>
        </div>
        <div class="input-small mr-20">
          <span>等级：</span>
          <el-select v-model="aaa" placeholder="请选择" class="elSel">
            <el-option label="消息" value="0"></el-option>
            <el-option label="预警" value="1"></el-option>
            <el-option label="告警" value="2"></el-option>
            <el-option label="通知" value="3"></el-option>
          </el-select>
        </div>
        <div class="input-small mr-20">
          <span>状态：</span>
          <el-select v-model="bbb" placeholder="请选择" class="elSel" clearable>
            <el-option label="全部" value=" "></el-option>
            <el-option label="未处理" value="1"></el-option>
            <el-option label="已确认" value="3"></el-option>
          </el-select>
        </div>
        <div class="input-small myinput">
          <span>时间：</span>
          <el-date-picker
            v-model="form.dataTime"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </div>

        <el-button type="primary" @click="searchEvents" class="search-btn"
          >查询</el-button
        >
      </div>

      <div class="elEvent_bottom" :style="{ height: tabHeights + 'px' }">
        <el-table
          :data="eventList"
          style="width: 100%"
          border
          :height="tabHeights - 20"
        >
          <el-table-column label="序号" width="60" align="center">
            <template slot="empty">
              <span class="noData">
                <img src="@/assets/noData.png" alt="暂无数据" />
                <span class="text">暂无数据</span>
              </span>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="linkobject" label="关联对象" width="160">
          </el-table-column>

          <el-table-column label="等级" width="85" align="center">
            <template #default="{row}">
              <div class="public-flex">
                <p class="myemergent mutongyong" v-if="row.eventlevel == '0'">
                  消息
                </p>
                <p class="myhigh mutongyong" v-if="row.eventlevel == '1'">
                  预警
                </p>
                <p class="mystandard mutongyong" v-if="row.eventlevel == '2'">
                  告警
                </p>
                <p class="mylow mutongyong" v-if="row.eventlevel == '3'">
                  通知
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="事件类型"
            width="110"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="time"
            label="时间"
            width="160"
            :formatter="formatTime"
          >
          </el-table-column>
          <el-table-column prop="description" label="内容" width="320">
          </el-table-column>

          <el-table-column label="状态" width="105" align="center">
            <template #default="{row}">
              <div class="patrol public-flex" v-if="row.eventstate == '3'">
                <p></p>
                <span>已确认</span>
              </div>
              <div class="overhaul public-flex" v-else>
                <p></p>
                <span>未处理</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="confirmuser" label="确认人"> </el-table-column>
          <el-table-column
            prop="confirmtime"
            label="确认时间"
            width="160"
            :formatter="formatTimeConfirm"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            width="120"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                v-if="scope.row.eventstate != '3'"
                @click="confirmEvent(scope.row)"
                style="color:#368ED9"
                >确认事件</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="divider-line"></div>
      <div class="paging">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="currentPage"
          :page-sizes="[15, 25, 35, 45, 55]"
          :page-size="15"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},

  data() {
    return {
      aaa: "2",
      bbb: "",
      getEventTypes: [
        {
          createTime: null,
          no: 1,
          name: "越限报警",
          typeName: "yxbj",
          soundType: 0,
          soundFile: "d:报警声.wav",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 1,
          telNum: "18689366741,13229775688",
          isUpSend: 1,
          isAutoShowCamera: 0,
          eventLevel: 2,
          id: "1",
          entityName: "EventType",
          soundTypeDesc: "无声音报警",
        },
        {
          createTime: null,
          no: 2,
          name: "变位报警",
          typeName: "bwbj",
          soundType: 0,
          soundFile: "",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 1,
          telNum: "13229775688",
          isUpSend: 1,
          isAutoShowCamera: 0,
          eventLevel: 2,
          id: "2",
          entityName: "EventType",
          soundTypeDesc: "无声音报警",
        },
        {
          createTime: null,
          no: 3,
          name: "故障报警",
          typeName: "gzbj",
          soundType: 1,
          soundFile: "",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 1,
          telNum: "13229775688",
          isUpSend: 1,
          isAutoShowCamera: 0,
          eventLevel: 1,
          id: "3",
          entityName: "EventType",
          soundTypeDesc: "读报警文字",
        },
        {
          createTime: null,
          no: 4,
          name: "用户操作事件",
          typeName: "czsj",
          soundType: 2,
          soundFile:
            "d:workdir上位机\u00003产品库wedoapplication\recwavealarm01.wav",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 0,
          telNum: "",
          isUpSend: 0,
          isAutoShowCamera: 0,
          eventLevel: 0,
          id: "4",
          entityName: "EventType",
          soundTypeDesc: "特定语音文件",
        },
        {
          createTime: null,
          no: 5,
          name: "系统事件",
          typeName: "xtsj",
          soundType: 2,
          soundFile:
            "d:workdir上位机\u00003产品库wedoapplication\recwavealarm01.wav",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 0,
          telNum: "",
          isUpSend: 0,
          isAutoShowCamera: 0,
          eventLevel: 0,
          id: "5",
          entityName: "EventType",
          soundTypeDesc: "特定语音文件",
        },
        {
          createTime: null,
          no: 6,
          name: "SOE事件",
          typeName: "soebj",
          soundType: 2,
          soundFile: "",
          typeImage: "",
          typeColor: -65536,
          isUse: 1,
          isAutoShowImage: 0,
          telNum: "",
          isUpSend: 0,
          isAutoShowCamera: 0,
          eventLevel: 0,
          id: "6",
          entityName: "EventType",
          soundTypeDesc: "特定语音文件",
        },
        {
          createTime: null,
          no: 7,
          name: "通信信息",
          typeName: "txxx",
          soundType: 0,
          soundFile: "",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 1,
          telNum: "",
          isUpSend: 1,
          isAutoShowCamera: 0,
          eventLevel: 2,
          id: "7",
          entityName: "EventType",
          soundTypeDesc: "无声音报警",
        },
        {
          createTime: null,
          no: 8,
          name: "温升报警",
          typeName: "wsbj",
          soundType: 1,
          soundFile: "",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 0,
          telNum: "",
          isUpSend: 1,
          isAutoShowCamera: 0,
          eventLevel: 0,
          id: "8",
          entityName: "EventType",
          soundTypeDesc: "读报警文字",
        },
        {
          createTime: null,
          no: 1000,
          name: "升温预警",
          typeName: "ed",
          soundType: 0,
          soundFile: "",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 0,
          telNum: "13175010610;13516757832",
          isUpSend: 1,
          isAutoShowCamera: 0,
          eventLevel: 1,
          id: "1000",
          entityName: "EventType",
          soundTypeDesc: "无声音报警",
        },
        {
          createTime: null,
          no: 1002,
          name: "电流越限",
          typeName: "dlyx",
          soundType: 0,
          soundFile: "",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 0,
          telNum: "13175010610;13516757832",
          isUpSend: 1,
          isAutoShowCamera: 0,
          eventLevel: 1,
          id: "1002",
          entityName: "EventType",
          soundTypeDesc: "无声音报警",
        },
        {
          createTime: null,
          no: 1003,
          name: "开门1报警",
          typeName: "km1bj",
          soundType: 1,
          soundFile: "",
          typeImage: "",
          typeColor: -1,
          isUse: 1,
          isAutoShowImage: 1,
          telNum: "",
          isUpSend: 1,
          isAutoShowCamera: 0,
          eventLevel: 2,
          id: "1003",
          entityName: "EventType",
          soundTypeDesc: "读报警文字",
        },
      ],
      tabHeights: Math.round(
        document.getElementById("app").clientHeight * 0.76
      ),
      form: {
        eventType: "",
        dataTime: [new Date(), new Date()],
      },
      eventList: [],
      state: -1,
      currentPage: 1,
      currentSize: 20,
      total: 0,
      loading: false,
    };
  },
  created() {},
  mounted() {
    debugPage = this;
    //默认全选
    this.form.eventType[0] = "全选";
    this.selectAll();
    this.searchEvents();
  },
  destroyed() {},
  computed: {
    eventStore() {
      return this.$store.eventStore;
    },
    nowUnit() {
      return this.$store.unitStore.getters.getNowUnit;
    },
    getLevelName() {
      return this.$store.eventStore.getters.getLevelName;
    },
    getStateName() {
      return this.$store.eventStore.getters.getStateName;
    },
  },

  methods: {
    formatEventLevel(row, column, cellValue) {
      return this.getLevelName(row.eventlevel);
    },
    formatterEventState(row, column, cellValue) {
      return this.getStateName(row.eventstate);
    },
    formatTime(row, column, cellValue) {
      return new Date(row.time).format("yyyy/MM/dd hh:mm:ss");
    },
    formatTimeConfirm(row, column, cellValue) {
      if (!isempty(row.confirmtime)) {
        return new Date(row.confirmtime).format("yyyy/MM/dd hh:mm:ss");
      }
    },
    selectAll() {
      if (this.form.eventType[0] == "全选") {
        this.getEventTypes.forEach((item) => {
          this.form.eventType.push(item.no);
        });
      } else {
        this.form.eventType = [];
      }
    },
    //分页功能
    handleSizeChange(val) {
      this.currentSize = val;
      this.searchEvents();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchEvents();
    },
    confirmEvent(row) {
      //确认事件
      this.$message.success("确认成功");
    },
    searchEvents() {
      //查询事件
      if (isempty(this.form.eventType)) {
        //事件类型为空
        this.$message.warning("事件类型不能为空");
        return;
      }
      let eventTypeNos = "";
      //bgTime变成0点0秒
      let y = this.form.dataTime[0].getFullYear();
      let m = this.form.dataTime[0].getMonth();
      let d = this.form.dataTime[0].getDate();
      let bgTime = new Date(y, m, d).getTime();
      //let bgTime = this.form.dataTime[0].getTime()
      //把0点0分变成23点59
      let endTime = this.form.dataTime[1].getTime() + 60 * 60 * 24 * 1000 - 1;
      this.form.eventType.forEach((item, index) => {
        if (item != "全选") {
          index + 1 < this.form.eventType.length
            ? (eventTypeNos += item + ",")
            : (eventTypeNos += item);
        }
      });
      var respon = {
        total: 21,
        data: [
          {
            no: 7218,
            type: 7,
            linkobject: "设备通道",
            confirmtime: 1712728134000,
            confirmuser: "1",
            time: 1712623751000,
            eventstate: 3,
            eventlevel: 2,
            description: "通道`设备通道`中断",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "中山市电气",
            unitId: "0A200022945047D7A5E538EDFC40FA2A",
            deviceNo: 13,
            deviceName: "水元一4011电线1211",
          },
          {
            no: 7239,
            type: 7,
            linkobject: "设备通道",
            confirmtime: null,
            confirmuser: "",
            time: 1713314907000,
            eventstate: 0,
            eventlevel: 2,
            description: "通道`设备通道`中断",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "中山市电气",
            unitId: "0A200022945047D7A5E538EDFC40FA2A",
            deviceNo: 13,
            deviceName: "水元一4011电线1211",
          },
          {
            no: 7217,
            type: 7,
            linkobject: "设备通道",
            confirmtime: 1712729464000,
            confirmuser: "1",
            time: 1712622155000,
            eventstate: 3,
            eventlevel: 2,
            description: "通道`设备通道`恢复",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "中山市电气",
            unitId: "0A200022945047D7A5E538EDFC40FA2A",
            deviceNo: 13,
            deviceName: "水元一4011电线1211",
          },
          {
            no: 7215,
            type: 7,
            linkobject: "设备通道",
            confirmtime: 1712728137000,
            confirmuser: "1",
            time: 1712484119000,
            eventstate: 3,
            eventlevel: 2,
            description: "通道`设备通道`中断",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "中山市电气",
            unitId: "0A200022945047D7A5E538EDFC40FA2A",
            deviceNo: 13,
            deviceName: "水元一4011电线1211",
          },

          {
            no: 7235,
            type: 7,
            linkobject: "配电房有源滤波",
            confirmtime: null,
            confirmuser: "",
            time: 1712891500000,
            eventstate: 0,
            eventlevel: 2,
            description: "通道`配电房有源滤波`中断",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "配电房",
            unitId: "FC0203DA14C845A4BA18E7F53DD5A4FC",
            deviceNo: 30,
            deviceName: "有源滤波器",
          },
          {
            no: 7214,
            type: 7,
            linkobject: "设备通道",
            confirmtime: 1712728230000,
            confirmuser: "1",
            time: 1712319467000,
            eventstate: 3,
            eventlevel: 2,
            description: "通道`设备通道`恢复",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "中山市电气",
            unitId: "0A200022945047D7A5E538EDFC40FA2A",
            deviceNo: 13,
            deviceName: "水元一4011电线1211",
          },
          {
            no: 7234,
            type: 7,
            linkobject: "设备通道",
            confirmtime: null,
            confirmuser: "",
            time: 1712891499000,
            eventstate: 0,
            eventlevel: 2,
            description: "通道`设备通道`恢复",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "中山市电气",
            unitId: "0A200022945047D7A5E538EDFC40FA2A",
            deviceNo: 13,
            deviceName: "水元一4011电线1211",
          },
          {
            no: 7224,
            type: 7,
            linkobject: "配电房有源滤波",
            confirmtime: null,
            confirmuser: "",
            time: 1712824151000,
            eventstate: 0,
            eventlevel: 2,
            description: "通道`配电房有源滤波`中断",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "配电房",
            unitId: "FC0203DA14C845A4BA18E7F53DD5A4FC",
            deviceNo: 30,
            deviceName: "有源滤波器",
          },

          {
            no: 7221,
            type: 7,
            linkobject: "设备通道",
            confirmtime: null,
            confirmuser: "",
            time: 1712824145000,
            eventstate: 0,
            eventlevel: 2,
            description: "通道`设备通道`恢复",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "中山市电气",
            unitId: "0A200022945047D7A5E538EDFC40FA2A",
            deviceNo: 13,
            deviceName: "水元一4011电线1211",
          },
          {
            no: 7220,
            type: 7,
            linkobject: "设备通道",
            confirmtime: null,
            confirmuser: "",
            time: 1712739597000,
            eventstate: 0,
            eventlevel: 2,
            description: "通道`设备通道`恢复",
            linkdevice: -858993460,
            typeName: "通信信息",
            limitedColor: null,
            unitName: "中山市电气",
            unitId: "0A200022945047D7A5E538EDFC40FA2A",
            deviceNo: 13,
            deviceName: "水元一4011电线1211",
          },
        ],
      };
      this.total = respon.total;
      var list = [];
      respon.data.map((v) => {
        if (v.eventlevel == this.aaa) {
          list.push(v);
        }
      });
      if (!this.bbb || this.bbb == " ") {
        this.eventList = list;
        console.log(111);
      } else {
        console.log(222);
        this.eventList = [];
        var a = [];
        var b = [];
        list.map((v) => {
          if (v.eventstate == 3) {
            a.push(v);
          } else {
            b.push(v);
          }
        });
        if (this.bbb == 3) {
          this.eventList = a;
        } else {
          this.eventList = b;
        }
      }

      console.log(this.eventList, "this.eventList");
    },
  },
};
</script>
<style>
.elSel {
  width: 90px;
}

.elSel input {
  width: 90px;
}
</style>
<style scoped lang="scss">
.myelEventBody {
  .con {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    background-color: #fff;
    padding: 2px 20px 20px 20px;
  }

  .paging {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }

  .public-flex {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // 巡检
  .patrol {
    p {
      width: 8px;
      height: 8px;
      background-color: #0dae88;
      border-radius: 50%;
      margin-right: 8px;
      position: relative;
      top: -1px;
    }

    span {
      color: #0dae88;
    }
  }

  // 检修
  .overhaul {
    p {
      width: 8px;
      height: 8px;
      background-color: #ff1d1d;
      border-radius: 50%;
      margin-right: 8px;
    }

    span {
      color: #ff1d1d;
    }
  }

  .mutongyong {
    width: 36px;
    height: 20px;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
  }

  //消息
  .myemergent {
    border: 1px solid #2981d2;
    color: #2981d2;
    background-color: #def3ff;
  }

  //预警
  .myhigh {
    border: 1px solid #ff7c1d;
    color: #ff7c1d;
    background-color: #fff1e7;
  }

  //告警
  .mystandard {
    border: 1px solid #ed6547;
    color: #ed6547;
    background-color: #ffecec;
  }

  //通知
  .mylow {
    border: 1px solid #0dae88;
    color: #0dae88;
    background-color: #8ef9df;
  }
}
</style>
